import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutDipComponent } from 'src/app/pages/about-dip/about-dip.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: AboutDipComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutDipRoutingModule { }
